<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 28.34 28.35"
	><g
		><path
			d="M6.11 20.76a1.4 1.4 0 0 0 0-2 11.777 11.777 0 0 1 0-16.32 1.4 1.4 0 0 0 0-2c-.43-.58-1.41-.58-1.98 0-5.51 5.57-5.51 14.74 0 20.32.56.57 1.55.57 1.98 0m16.12-2.15a1.4 1.4 0 0 0 0 2c.56.57 1.41.57 1.98 0 5.51-5.58 5.51-14.6 0-20.19-.56-.57-1.41-.57-1.98 0a1.4 1.4 0 0 0 0 2c4.38 4.59 4.38 11.74 0 16.18Z"
		/><path
			d="M8.23 16.61c.56.57 1.41.57 1.98 0a1.4 1.4 0 0 0 0-2c-2.26-2.29-2.26-5.87 0-8.16a1.4 1.4 0 0 0 0-2c-.56-.57-1.41-.57-1.98 0-3.39 3.43-3.39 8.87 0 12.16m9.9 0c.56.57 1.41.57 1.98 0 3.25-3.29 3.25-8.73 0-12.17-.56-.57-1.41-.57-1.98 0a1.4 1.4 0 0 0 0 2c2.26 2.29 2.26 5.87 0 8.16-.56.58-.56 1.43 0 2.01"
		/><path
			d="M22.65 25.34h-2.83L15.3 13.17c1.13-.43 1.98-1.86 1.56-3.29-.28-1-1.13-1.86-2.12-2-1.84-.43-3.39.86-3.39 2.72 0 1.15.71 2.15 1.7 2.58L8.53 25.35H5.7l-2.83 3.01h22.62l-2.83-3.01Z"
		/></g
	></svg
>
